import Crud from '../views/PesquisaMaterial/Crud'

let routes = {
    path: '/pesquisa-material',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/pesquisa-material',
            name: 'list-pesquisa-material',
            component: Crud,
            meta: {
                pageTitle: 'Pesquisa de Material',
                breadcrumb: [
                    {
                        text: 'Pesquisa de Material',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes